import { render, staticRenderFns } from "./Brokers.vue?vue&type=template&id=4029fd9c&scoped=true&"
import script from "./Brokers.vue?vue&type=script&lang=js&"
export * from "./Brokers.vue?vue&type=script&lang=js&"
import style0 from "./Brokers.vue?vue&type=style&index=0&id=4029fd9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4029fd9c",
  null
  
)

export default component.exports